import React, { Component } from 'react'
import Select from 'react-select'
import apiService from '../../services/apiservices'

class Kitchens extends Component {
    constructor() {
        super()
        this.state = {
            kitchensList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getKitchensList()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getKitchensList = () => {
        apiService.getKitchensDetailList()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        kitchensList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }
    

    render() {
        let list = {}
        list = Object.keys(this.state.kitchensList).map((value,index) => {
            
            return {
                label : this.state.kitchensList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Kitchen"
                options={list}
                onChange={(e) => { (e) ? this.props.kitchenChange(e) : this.props.kitchenChange([])}}
                />
            </div>
        )
    }
}
export default Kitchens


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/DropDowns/Kitchens.js